import React, { useCallback, useImperativeHandle, useState } from 'react'
import PropTypes from 'prop-types'
import RoundedModal from '../../../../../../molecules/RoundedModal'
import ModifyReportAttributesForm from './form'

const ModifyReportAttributesDialog = React.forwardRef(function ModifyReportAttributesDialog ({ onComplete }, ref) {
  const [dialogState, setDialogState] = useState({ open: false, processing: false })

  const close = useCallback(() => {
    setDialogState({ open: false, processing: false })
  }, [setDialogState])

  const handleComplete = useCallback((e) => {
    close()
    onComplete(e)
  }, [close, onComplete])

  useImperativeHandle(ref, () => ({
    open: (report) => {
      setDialogState({ open: true, processing: false, report })
    }
  }), [setDialogState])

  return (
    <RoundedModal
      title='Modify Denali View'
      open={dialogState.open}
      onClose={close}
      position='top'
      disablePortal={false}
    >
      <div>
        {dialogState.open ? (
          <ModifyReportAttributesForm
            report={dialogState.report}
            onComplete={handleComplete}
            onCancel={close}
          />
        ) : null}
      </div>
    </RoundedModal>
  )
})

ModifyReportAttributesDialog.propTypes = {
  onComplete: PropTypes.func
}

ModifyReportAttributesDialog.defaultProps = {
  onComplete: () => {}
}

export default ModifyReportAttributesDialog
